import * as ko from 'knockout';
import validateInfo from 'ko/bindings/validate.shared';

function validationContainerBindingHandler() {
    const errorCssClass = 'error';
    const validationMsgClassName = 'validation-msg';
    const bindingHandlers = ko.bindingHandlers;

    return {
        init: function (elm, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            const value = valueAccessor();
            if (value) {
                // supports validation
                if (value.hasErrors) {
                    const span = document.createElement('span');
                    span.className = validationMsgClassName;
                    span.appendChild(document.createElement('span'));

                    elm.insertBefore(span, null);
                } else {
                    console.warn('Init "validationContainer" binding: ignored because it bound to observable that has no validation extension.');
                }
            }
        },

        update: function (elm, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            const value = valueAccessor();
            if (!value) {
                return;
            }
            if (!value.hasErrors) {
                console.warn('Update "validationContainer" binding: ignored because it bound to observable that has no validation extension.');
                return;
            }

            const validationSpan = elm.getElementsByClassName(validationMsgClassName)[0];
            const innerSpan = validationSpan.lastChild;
            const validationAttempted = bindingContext[validateInfo.validationAttemptedBindingName];
            const textAccessor = value.validationMessage;
            const visibleAccessor = function () {
                const hasErrors = value.hasErrors();
                const attemptedDefined = !!validationAttempted;
                const isDirtyDefined = !!value.isDirty;
                const attempted = attemptedDefined ? validationAttempted() : false;
                const isDirty = isDirtyDefined ? value.isDirty() : false;

                // if both attempted and isDirty undefined, ignore them
                // in order to switch visible state properly
                if (!attemptedDefined && !isDirtyDefined) {
                    return hasErrors;
                }

                return hasErrors && (attempted || isDirty);
            };
            const hasErrorClass = visibleAccessor();

            bindingHandlers.text.update(innerSpan, textAccessor);
            bindingHandlers.visible.update(validationSpan, visibleAccessor);

            const prevSub = ko.utils.domData.get(elm, 'validationAttemptedSub');
            if (prevSub) {
                prevSub.dispose();
            }
            const newSub = validationAttempted?.subscribe(function () {
                bindingHandlers.visible.update(validationSpan, visibleAccessor);
                ko.utils.toggleDomNodeCssClass(elm, errorCssClass, visibleAccessor());
            });
            if (newSub) {
                ko.utils.domData.set(elm, 'validationAttemptedSub', newSub);
            }

            ko.utils.toggleDomNodeCssClass(elm, errorCssClass, hasErrorClass);
        },
    };
}

ko.bindingHandlers['validationContainer'] = validationContainerBindingHandler();
